import React, { Component } from "react";
import {Link, useNavigate,useLocation, useParams} from "react-router-dom";
import '../../style/generic.css';
import '../../style/footer.css';
import logo from '../../images/logo.png';
import inst from '../../images/instagram.png';
import youtube from '../../images/youtube.png';
import facebook from '../../images/facebook.png';
import ButtonMailto from "../hooks/mailTO";
import { withRouter } from "../hooks/navigation";

const isMobile = window.innerWidth < 768;

class Footer extends Component{
 constructor(props){
    
    super(props);
  };
componentDidMount() {
console.log(this.props.location);
}
 
 
  render(){
    
    return (
    <>
    <section className="footerSection">
   
    <div className="container">
    { (this.props.location.pathname != null && (this.props.location.pathname.includes("categoria") || this.props.location.pathname.includes("video"))) &&
      <div className="divider-footer"></div>
    }
     
   
     <div className="padding-top-48 padding-bottom-48">
     <div className={"flex horizontal justify-spacebetween  footermobile " + (isMobile ? "padding-bottom-40":"padding-bottom-80")}>
     <div className="logo">
     <img src={logo} width={88} height={50}></img>
    </div>
    <div className="flex horizontal footermobile">
    <div className="flex vertical space-evenly linkfooter align-start" >
      <div>POLICY</div>
      <div><a href="https://www.alis.it/privacy-policy/" target="_blank">Cookie Policy</a></div>
      <div><a href="https://www.alis.it/privacy-policy/" target="_blank">Privacy</a></div>
    </div>
    <div className="flex vertical space-evenly linkfooter align-start mobile-padding-top-40">
      <div>CONTATI</div>
      <div><ButtonMailto label="redazione@alischannel.it" mailto="mailto:redazione@alischannel.it" /></div>
      <div className="flex horizontal iconSocial">
      <div><a href="https://www.youtube.com/channel/UCpzAburIOHWpOcY6RUQX_ZQ" target="_blank"><img src={youtube} width={36} height={36}></img></a></div>
      <div><a href="https://www.instagram.com/alis_channel_tv/" target="_blank"><img src={inst} width={36} height={36}></img></a></div>
      <div><a href="https://www.facebook.com/tv.alis.channel/" target="_blank"><img src={facebook} width={36} height={36}></img></a></div>
      </div>
    </div>
    </div>
    

     </div>      
     <div className="flex horizontal justify-spacebetween verticalMobile">
    <div className="flex vertical">
     <div className="copyright">2025 © Copyright ALIS, Associazione Logistica dell’Intermodalità Sostenibile</div>
     <div className="copyright left">Via Rasella, 157 – 00187 Roma | C.F. 97907840587</div>
    </div>
    <div className={"flex vertical " + (isMobile ? "padding-top-16":"")}>
    <div className="copyright padding-righ-100"><a href="https://www.pushapp.me" target="_blank">Crafted by <span className="boldPush">Pushapp</span></a></div>
    
    </div>
    </div>   
    </div>
    </div>
    </section>
</>
    )
}
}
export default withRouter(Footer);